import BaseAPI from './base/base-api';

class OptionAPI extends BaseAPI {
    constructor() {
        super();
    }
    urlName = 'ManagementAPI';
    controllerName = 'option';
}

export default new OptionAPI();
